import type { ReactNode } from 'react'
import FlightForm from '@/components/Flights/HorizonForm/HorizonFlightForm'
import SearchForm from '@/components/Hotels/HorizonForm/HorizonHotelForm'
import { handleSubmitForHotels } from '@/components/Hotels/SearchForm/utils'
import type { SearchFormProductHeadlineType } from '@/components/SearchForm/types'
import type { LOCATION_SEARCH_TYPE, ProductType } from '@/types'

import CarsForm from '@/components/Cars/HorizonForm/HorizonCarForm'
import HorizonCruiseForm from '@/components/Cruises/HorizonForm/HorizonCruiseForm'
import { onSubmit as onSubmitFlight } from '@/components/Flights/SearchForm/utils'
import HorizonPackagesForm from '@/components/Packages/HorizonForm/HorizonPackagesForm'
import { onSubmit } from '@/components/Packages/SearchForm/utils'
import {
  CarsBumper,
  CruiseBumper,
  FlightsBumper,
  HotelsBumper,
  VacationBumper,
} from '../../SearchForm/Bumpers'

const renderHomepageSearchForm = (component: ReactNode) => (
  <div className='mx-auto w-full max-w-[48rem]'>{component}</div>
)

export default function getProductCategory(
  productType: ProductType,
  values: SearchFormProductHeadlineType,
  setLocation?: (key: LOCATION_SEARCH_TYPE | undefined) => void,
  showHotelTypeButtons?: boolean,
) {
  switch (productType) {
    case 'flights':
      return {
        component: renderHomepageSearchForm(<FlightForm onSubmit={onSubmitFlight} pageName='homepage' />),
        bumper: <FlightsBumper />,
        headline: values.flights.headline,
      }
    case 'cars':
      return {
        component: renderHomepageSearchForm(<CarsForm />),
        bumper: <CarsBumper />,
        headline: values.cars.headline,
      }
    case 'vacations':
      return {
        component: renderHomepageSearchForm(<HorizonPackagesForm pageName='homepage' onSubmit={onSubmit} />),
        bumper: <VacationBumper />,
        headline: values.vacations.headline,
      }

    case 'cruises':
      return {
        component: renderHomepageSearchForm(<HorizonCruiseForm />),
        bumper: <CruiseBumper richText={values.cruises.bumper} />,
        headline: values.cruises.headline,
      }

    default:
      return {
        component: (
          renderHomepageSearchForm(
            <SearchForm
              onSubmit={handleSubmitForHotels}
              setLocation={setLocation}
              showHotelTypeButtons={showHotelTypeButtons}
              pageName='homepage'
            />,
          )
        ),
        bumper: <HotelsBumper />,
        headline: values.hotels.headline,
      }
  }
}
